import { formatDate } from "../../../shared/helper/formatadores";
import { obterCampoAdicionalPorSiglaIgnoreCase, obterCampoAdicionalPorTipoDocumento } from "../disponibilidade/helper";
import { obterDataCessacaoBeneficio, obterSiglaTipoPericiaProrrogacaoParaPMF, obterSiglaTipoPericiaAgendavelPMF } from "../helper";

import { 
  SIGLA_CAMPO_ADICIONAL_DATA_PRIMEIRO_AGENDAMENTO_PERICIA, 
  SIGLA_CAMPO_ADICIONAL_SITUACAO_PRIMEIRO_AGENDAMENTO_PERICIA, 
  SIGLA_CAMPO_ADICIONAL_TIPO_PERICIA_PRORROGACAO 
} from "../selecaoServicos/siglaServico";

import dayjs from "dayjs";
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'

dayjs.extend(isSameOrAfter);

export const SITUACAO_PERICIA_PRORROGACAO_AGENDADA = 'AGENDADO';
export const SITUACAO_PERICIA_PRORROGACAO_SEM_NECESSIDADE = 'SEM_NECESSIDADE_DE_AGENDAMENTO';
export const SITUACAO_PERICIA_PRORROGACAO_SEM_VAGA = 'VAGA_NAO_ENCONTRADA';
export const SITUACAO_PERICIA_PRORROGACAO_ERRO_AGENDAR = 'ERRO_AO_TENTAR_AGENDAR';
export const SITUACAO_PERICIA_PRORROGACAO_VAGA_DISTANTE = 'VAGA_DISTANTE';

export const isPericiaPmanSemAgendarVaga = (
  requerimentoTO
) => {
  let campoTipoPericiaProrrogacao = obterCampoAdicionalPorSiglaIgnoreCase(
    requerimentoTO?.dadosAdicionais,
    SIGLA_CAMPO_ADICIONAL_TIPO_PERICIA_PRORROGACAO
  );

  // Se o campo Tipo PP estiver vazio, é PMAN
  let isPMAN = !campoTipoPericiaProrrogacao || !campoTipoPericiaProrrogacao.valor || campoTipoPericiaProrrogacao.valor === 'PMAN';

  // A APS onde a tarefa foi criada é a APS de Manutenção
  let apsManutencaoPermiteBuscarAgendaPMAN = requerimentoTO?.disponibilidade?.deveBuscarAgendaPMAN;  

  // PMAN sem agendar vaga
  return isPMAN && !apsManutencaoPermiteBuscarAgendaPMAN;
};

export const isPericiaPmanComTentativaAgendamento = (
  requerimentoTO
) => {
  let campoTipoPericiaProrrogacao = obterCampoAdicionalPorSiglaIgnoreCase(
    requerimentoTO?.dadosAdicionais,
    SIGLA_CAMPO_ADICIONAL_TIPO_PERICIA_PRORROGACAO
  );

  // Se o campo Tipo PP estiver vazio, é PMAN
  let isPMAN = !campoTipoPericiaProrrogacao || !campoTipoPericiaProrrogacao.valor || campoTipoPericiaProrrogacao.valor === 'PMAN';
  
  // A APS onde a tarefa foi criada é a APS de Manutenção
  let apsManutencaoPermiteBuscarAgendaPMAN = requerimentoTO?.disponibilidade?.deveBuscarAgendaPMAN;  

  // PMAN que deve agendar
  return isPMAN && apsManutencaoPermiteBuscarAgendaPMAN;
};

export const isProrrogacaoSemNecessidadeAgendamento = (requerimentoTO) => {
  let campoSituacaoAgendaPericia = obterCampoAdicionalPorSiglaIgnoreCase(
    requerimentoTO?.dadosAdicionais,
    SIGLA_CAMPO_ADICIONAL_SITUACAO_PRIMEIRO_AGENDAMENTO_PERICIA
  );
  if (
    campoSituacaoAgendaPericia?.valor ===
    SITUACAO_PERICIA_PRORROGACAO_SEM_NECESSIDADE
  ) {
    return true;
  } else {
    return false;
  }
};

export const isProrrogacaoComErroAgendamentoPericia = (requerimentoTO) => {
  let campoSituacaoAgendaPericia = obterCampoAdicionalPorSiglaIgnoreCase(
    requerimentoTO?.dadosAdicionais, SIGLA_CAMPO_ADICIONAL_SITUACAO_PRIMEIRO_AGENDAMENTO_PERICIA);
  if (campoSituacaoAgendaPericia?.valor === SITUACAO_PERICIA_PRORROGACAO_ERRO_AGENDAR) {
    return true;
  } else {
    return false;
  }
}

export const isProrrogacaoSemVagaAgendamento = (requerimentoTO) => {
  let campoSituacaoAgendaPericia = obterCampoAdicionalPorSiglaIgnoreCase(
    requerimentoTO?.dadosAdicionais, SIGLA_CAMPO_ADICIONAL_SITUACAO_PRIMEIRO_AGENDAMENTO_PERICIA);
  if (campoSituacaoAgendaPericia?.valor === SITUACAO_PERICIA_PRORROGACAO_SEM_VAGA) {
    return true;
  } else {
    return false;
  }
}

export const obterPedidoPericiaProrrogacaoTO = (requerimentoTO, pessoaCnis) => {

  let dadosRequerente = {
    cpf: requerimentoTO?.dadosRequerente?.cpf,
    nit: requerimentoTO?.dadosRequerente?.nit,
    dataNascimento: formatDate(requerimentoTO?.dadosRequerente?.dataNascimento, 'YYYY-MM-DD hh:mm:ss', 'YYYY-MM-DD'),
    strDataNascimento: requerimentoTO?.dadosRequerente?.strDataNascimento,
    atualizouDadosCadastrais: requerimentoTO?.dadosRequerente?.atualizouDadosCadastrais,
    nome: requerimentoTO?.dadosRequerente?.nome ?? pessoaCnis.nome,
    nomeMae: requerimentoTO?.dadosRequerente?.nomeMae,
    telFixo: requerimentoTO?.contato?.telResidencialTO?.numero?.replace(/\D/g, ""),
    telCelular: requerimentoTO?.contato?.celularTO?.numero?.replace(/\D/g, ""),
    email: requerimentoTO?.contato?.email,
    acompanharAndamentoProcesso: requerimentoTO?.contato?.aceitaAcompanhar,
    genero: pessoaCnis.codigoSexo === 1 ? 'MASCULINO' : pessoaCnis.codigoSexo === 3 ? 'FEMININO' : 'NAO_INFORMADO'
  };

  let dadosAdicionais = [];

  let campoNB = obterCampoAdicionalPorTipoDocumento(requerimentoTO?.dadosAdicionais, 'NB');
  if (campoNB) {
    dadosAdicionais.push({
      valor: campoNB.valor,
      nome: campoNB.nome,
      sigla: campoNB.tipoDocumento,
      idServicoCampoAdicional: campoNB.idServicoCampoAdicional,
      tipoCampoAdicional: campoNB.tipoCampoAdicional,
      tipoDocumento: campoNB.tipoDocumento,
      tipoExigenciaDocumento: campoNB.tipoExigenciaDocumento,
      bloqueavel: campoNB.bloqueavel,
      ativo: campoNB.ativo
    });
  }

  return {
    numeroProtocoloTarefaINSS: requerimentoTO?.protocoloRequerimento?.toString(),
    dataEntradaRequerimento: requerimentoTO?.dataEntradaRequerimento ?? requerimentoTO?.dataCriacao,
    idUOConcessoraMantenedora: requerimentoTO?.idUOConcessoraMantenedora ?? requerimentoTO?.idUOMantenedora,
    idUOConcessora: requerimentoTO?.idUOConcessora ?? requerimentoTO?.idUOMantenedora,
    idUOMantenedora: requerimentoTO?.idUOMantenedora,
    dadosRequerente: dadosRequerente,
    dadosAdicionais: dadosAdicionais.length > 0 ? dadosAdicionais : requerimentoTO?.dadosAdicionais,
    origemSolicitacao: 'INTERNET',
    sistemaSolicitante: 'MEU_INSS',
    tipoPericia: obterSiglaTipoPericiaProrrogacaoParaPMF(requerimentoTO),
    dataCessacaoBeneficio: obterDataCessacaoBeneficio(requerimentoTO)
  }
}

export const obterSiglaTipoPericiaAgendaPMF = requerimentoTO => {
  return obterSiglaTipoPericiaAgendavelPMF(requerimentoTO);
}

export const isEspecieParaProrrogocao = (servicoSelecionado, beneficio) => {
  return Array.isArray(servicoSelecionado?.listaNumeroEspecieBeneficio) &&
    servicoSelecionado?.listaNumeroEspecieBeneficio?.includes(beneficio?.codigoEspecie);
}

export const isSituacaoParaProrrogacao = (servicoSelecionado, beneficio) => {
  return Array.isArray(servicoSelecionado?.listaSituacaoBeneficio) &&
    servicoSelecionado?.listaSituacaoBeneficio?.find((tipoSituacao) =>
      tipoSituacao?.nome.toUpperCase() === beneficio?.situacao);
}

export const isDataCessacaoParaProrrogacao = (beneficio) => {
  if (beneficio.dataCessacao) {
    const dataCessacao = dayjs(beneficio.dataCessacao).add(3, 'hour');
    return dataCessacao.isSameOrAfter(dayjs().add(3, 'hour'), 'day');
  } else {
    return true; // não há data de cessação, portanto, está ativo
  }
}

export const isCampoAdicionalDataAgendaPericia = campoAdicional => {
  return campoAdicional.sigla === SIGLA_CAMPO_ADICIONAL_DATA_PRIMEIRO_AGENDAMENTO_PERICIA;
}

export const isPericiaPman = (
  requerimentoTO
) => {
  let campoTipoPericiaProrrogacao = obterCampoAdicionalPorSiglaIgnoreCase(
    requerimentoTO?.dadosAdicionais,
    SIGLA_CAMPO_ADICIONAL_TIPO_PERICIA_PRORROGACAO
  );

  // Se o campo Tipo PP estiver vazio, é PMAN
  let isPMAN = (campoTipoPericiaProrrogacao && !campoTipoPericiaProrrogacao.valor) || campoTipoPericiaProrrogacao?.valor === 'PMAN';
  // PMAN
  return isPMAN;
};